<template>
  <v-app>
    <div id="home">
      <CCHeader
        :key="'home'"
        :username="GET_CREATOR.name_ccid"
        class="headerarea"
      />
      <div
        v-if="loggedin"
        class="content"
      >
        <div class="actionarea">
          <div class="leftblank" />
          <div class="centerarea">
            <div
              v-if="isstudent"
              id="student"
              style="margin: 0 10%; padding: 10px;"
            >
              <br>
              <b style="color:red">This system is not for students!</b>
              <br>
              <br>This system is for instructors to create their courses in eClass or Canvas.
              If you are a student and need to register in courses, please do so using
              <a
                href="https://www.beartracks.ualberta.ca"
                target="_blank"
              >Bear Tracks.</a>
              <br>
              <br>As a student, all of your courses will automatically show up in your eClass or Canvas Dashboard
              (within 24 hours after you register in the course).
              <br>
              <br>If you do not see an expected course on your eClass or Canvas Dashboard, please review
              <a
                href="https://support.eclass.ualberta.ca/index.php?/Knowledgebase/Article/View/28/6/problems-accessing-eclass-courses"
                target="_blank"
              >this article.</a>
              <br>
              <br>If you think you should have access to create a course please contact eclass@ualberta.ca
              <br>
              <br>
              <a
                href="https://eclass.srv.ualberta.ca/my/"
                target="_blank"
              >
                <button
                  id="goBack"
                  class="btn btn-success"
                >Go back</button>
              </a>
            </div>
            <div
              v-else-if="issecondary"
              id="secondary"
              style="margin: 0 10%; padding: 10px;"
            >
              <br>
              <b style="color:red">This system cannot be used by secondary CCIDs</b>
              <br>
              Please login with your primary CCID.
              <br>
              <br>If you think you should have access to create a course please contact eclass@ualberta.ca
              <br>
              <br>
              <a
                href="https://eclass.srv.ualberta.ca/portal/"
                target="_blank"
              >
                <button
                  id="goBack"
                  class="btn btn-success"
                >Go back</button>
              </a>
            </div>
            <!-- button to use router to get to workflow.vue if an instructor-->
            <div
              v-else
              id="instructor"
            >
              <div style="margin: 0 10%; padding-bottom: 10px;">
                <h1 style="font-weight: 400; color: #275d38; margin-bottom: 1rem;">
                  Course Request System
                </h1>
                <p>
                  This system enables instructors and U of A staff to create <a
                    target="_blank"
                    href="https://support.eclass.ualberta.ca/Knowledgebase/Article/View/558/0/creating-credit-courses-on-canvas"
                  >
                    Bear Tracks Credit, </a> <a
                    target="_blank"
                    href="https://support.eclass.ualberta.ca/Knowledgebase/Article/View/525/53/accessing-sandbox-courses-on-canvas#co-curricular"
                  >Co-Curricular,</a>
                  or <a
                    target="_blank"
                    href="https://support.eclass.ualberta.ca/Knowledgebase/Article/View/525/53/accessing-sandbox-courses-on-canvas#additional-sandboxes"
                  >Sandbox</a> courses on Canvas. If you have any questions, 
                  please contact eClass support at eclass@ualberta.ca or 780-492-9372.
                  <br><br>
                  While eClass is transitioning to a read-only state after Summer 2025 and all new credit and 
                  co-curricular courses must be requested on Canvas only, it is still possible to create <a
                    target="_blank"
                    href="https://support.eclass.ualberta.ca/index.php?/Knowledgebase/Article/View/59/13/eclass-external-service"
                  >
                    eClass External courses. </a>
                  <br><br>
                  All use of this system is governed by the
                  <a
                    target="_blank"
                    href="https://policiesonline.ualberta.ca/PoliciesProcedures/Policies/Information-Technology-Use-and-Management-Policy.pdf"
                  >
                    Campus Computing and IT Use Policy.
                  </a> Credit courses created on eClass will be automatically archived 4 years after the term in which they are offered as per our
                  <a
                    target="_blank"
                    href="https://support.eclass.ualberta.ca/index.php?/News/NewsItem/View/107/eclass-course-archiving-june-2017"
                  >
                    data retention schedule.
                  </a>
                </p>
              </div>
              <div id="instrbuttons">
                <router-link
                  tag="button"
                  class="btn btn-secondary requestcourse"
                  :to="{ name: 'workflow' }"
                  style="text-align: center;"
                >
                  Request on eClass
                </router-link>
                <router-link
                  tag="button"
                  class="btn btn-secondary requestcourse"
                  :to="{ name: 'canvasworkflow' }"
                  style="text-align: center; margin-left: 30px;"
                >
                  Request on Canvas
                </router-link>
                <br>
                <router-link
                  tag="button"
                  class="btn btn-success myrequests"
                  :to="{ name: 'myrequests' }"
                  style="text-align: center; margin-top: 14px;"
                >
                  My eClass Requests
                </router-link>
                <router-link
                  tag="button"
                  class="btn btn-success myrequests"
                  :to="{ name: 'canvasmyrequests' }"
                  style="text-align: center; margin-top: 14px; margin-left: 30px;"
                >
                  My Canvas Requests
                </router-link>
              </div>
            </div>

            <div
              v-if="isadmin"
              id="admin"
            >
              <router-link
                :to="{ name: 'airport' }"
                style="text-align: center;"
              >
                <button
                  id="manageAirport"
                  class="btn btn-success"
                >
                  Airport security
                </button>
              </router-link>
              <router-link
                :to="{ name: 'canvasairport' }"
                style="text-align: center; margin-left: 25px;"
              >
                <button
                  id="canvasAirport"
                  class="btn btn-success"
                >
                  Canvas security
                </button>
              </router-link>
            </div>
          </div>
          <div class="rightblank" />
        </div>
        <div class="picturearea">
          <img
            src="./../../public/UA_064_RGB.png"
            style="max-width: 100%"
            alt="UofA image with patterned U and A overlapping"
          >
        </div>
      </div>

      <CCFooter class="footer" />
    </div>
  </v-app>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapState, mapActions } from 'vuex';

import CCFooter from '@/components/CCFooter.vue';

import CCHeader from '@/components/CCHeader.vue';

export default {
    name: 'HomeView',
    components: {
        CCFooter,
        CCHeader,
    },
    data() {
        return {
            role: 'Instructor',
        };
    },
    computed: {
        ...mapState(['isadmin', 'isstudent', 'issecondary', 'loggedin']),
        ...mapGetters({
            GET_CREATOR: 'GET_CREATOR',
        }),
    },
    created() {
        if (this.loggedin) {
            this.FETCH_TERM_CODES();
            this.FETCH_ROLES();
        } else {
            this.$router.push({ name: 'login' });
        }
    },
    methods: {
        ...mapActions(['FETCH_ROLES', 'FETCH_TERM_CODES']),
    },
};
</script>

<style lang="scss" scoped>
#home {
    display: grid;
    height: 100%;
    grid-template-columns: 1fr;
    grid-template-rows: 4em 1fr 2em;
    grid-template-areas:
        'headerarea'
        'content'
        'footer';
}

#admin {
    display: flex;
    justify-content: center;
    button {
        margin-bottom: 10px;
    }
}

#manageAirport, #canvasAirport {
    background-color: #f5f5f5;
    border: 2px solid #275D38;
    color: #275D38;
}
#manageAirport:hover, #canvasAirport:hover {
    background-color: #f5f5f5;
    border: 2px solid #6CC24A;
    color: #6CC24A;
}

.headerarea {
    grid-area: headerarea;
}

.content {
    grid-area: content;
    display: grid;
    grid-template-rows: 1fr auto 1fr;
    grid-template-columns: 2fr 1fr;
    grid-template-areas:
        'top top'
        'actionarea picturearea'
        'bottom bottom';
}

.centerarea {
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    label {
        margin-bottom: 0.1rem;
    }
}

.footer {
    grid-area: footer;
}

.actionarea {
    margin: auto;
    grid-area: actionarea;
    .btn {
        margin-top: 4px;
    }
}

.picturearea {
    grid-area: picturearea;
    padding: 20px 10% 20px 0px;
}

#instrbuttons {
    text-align: center;
    margin-bottom: 14px;
}

a {
    color: #6CC24A !important;
    font-weight: 500;
    text-decoration: none;
}

#instructor {
    display: flex;
    flex-direction: column;
}
#student {
    padding-bottom: 100px;
}

.btn {
    width: 180px;
}

@media only screen and (max-width: 966px) {
  .picturearea {
    display: none;
  }
  .content {
    grid-area: content;
    display: grid;
    grid-template-rows: 1fr auto 1fr;
    grid-template-columns: auto;
    grid-template-areas:
        'top'
        'actionarea'
        'bottom';
    }
}

</style>
